export function fullDiscountRuleHandle(_this) {
  _this.fullDiscountChooseNums = {}
  _this.fullDiscountmoney = 0
  _this.list.map((item) => {
    if (item.ischoose && item.isFullDiscount == 1 && item.fullDiscountRuleId) {
      let ruleId = item.fullDiscountRuleId
      if (_this.fullDiscountChooseNums[ruleId]) {
        _this.fullDiscountChooseNums[ruleId] += parseInt(item.num)
      } else {
        _this.fullDiscountChooseNums[ruleId] = parseInt(item.num)
      }
    }
  })
  if (_this.fullDiscountRuleList && _this.fullDiscountRuleList.length) {
    let rulelist = _this.fullDiscountRuleList
    _this.list.map((item) => {
      if (item.ischoose && item.isFullDiscount == 1 && item.fullDiscountRuleId) {
        let ruleId = +item.fullDiscountRuleId
        let chooselen = _this.fullDiscountChooseNums[ruleId]
          ? _this.fullDiscountChooseNums[ruleId]
          : 0
        for (let i = 0; i < rulelist.length; i++) {
          if (
            rulelist[i].ruleId == ruleId &&
            (((item.ischoose == true || item.ischoose == 1) &&
              chooselen >= parseInt(rulelist[i].num)) ||
              item.num >= parseInt(rulelist[i].num))
          ) {
            item.fullDiscountPrice =
              parseFloat(item.sales_price) -
              parseFloat(item.price) * parseFloat(rulelist[i].discount)
            _this.fullDiscountmoney += item.fullDiscountPrice * item.num
          } else {
            item.fullDiscountPrice = 0
          }
        }
      } else {
        item.fullDiscountPrice = 0
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/shopcart/js/recommendProducts.js